export default __webpack_public_path__ + "static/media/social_share_low.8d142cdc.png";